import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: {},
    scrollRestoration: true,
  });

  return router;
};

// 注意：根 tsconfig 同时覆盖 CRM 与本应用，Register 增强由 CRM 侧声明，
// 本应用不再重复 augment（否则两个 router 类型冲突）。
